export default __webpack_public_path__ + "efd217b39eb4611079da8947b3149e6a.svg";